'use client'

import { FavoriteButton } from 'product-card/components/shared/FavoriteButton'
import { PdpLink } from 'product-card/components/shared/PdpLink'
import { ColorPicker } from 'product-card/components/shared/ProductColor/ColorPicker'
import { ProductPrice } from 'product-card/components/shared/ProductPrice'
import { ProductTitle } from 'product-card/components/shared/ProductTitle'
import { useProductCardContext } from 'product-card/hooks/useProductCardContext'
import type { Product } from 'product/types'
import type { ProductPrices } from 'product/types/Prices'

import { ProductTags } from '../../shared/ProductTags'

import styles from './ProductDetails.module.scss'

interface ProductDetailsProps {
	productId: string
	product: Product
	prices?: ProductPrices
	showAsFeatured: boolean
}

export const ProductDetails = ({
	productId,
	product,
	prices,
	showAsFeatured,
}: ProductDetailsProps) => {
	const { hasColorPicker } = useProductCardContext()

	return (
		<div className={styles.productDetails}>
			<div className={styles.productInfo}>
				<div className={styles.tagsTitleContainer}>
					<ProductTags productTags={product.tags} />
					<ProductTitle productName={product.name} />
				</div>
				<FavoriteButton product={product} productId={productId} />
			</div>

			<ProductPrice productId={productId} prices={prices} />

			{(hasColorPicker || showAsFeatured) && (
				<>
					<PdpLink
						showAsFeatured={showAsFeatured}
						product={product}
						productColors={product.colors}
					/>
					<ColorPicker
						showAsFeatured={showAsFeatured}
						productColors={product.colors}
					/>
				</>
			)}
		</div>
	)
}
